'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _require = require('./utils'),
    parseArgs = _require.parseArgs;

var _require2 = require('../../utils'),
    withTimeoutOption = _require2.withTimeoutOption;

module.exports = function (_ref) {
  var ipld = _ref.ipld,
      preload = _ref.preload;
  return withTimeoutOption( /*#__PURE__*/function () {
    var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cid, path, options) {
      var _parseArgs, _parseArgs2, value, result, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, entry;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _parseArgs = parseArgs(cid, path, options);
              _parseArgs2 = _slicedToArray(_parseArgs, 3);
              cid = _parseArgs2[0];
              path = _parseArgs2[1];
              options = _parseArgs2[2];

              if (options.preload !== false) {
                preload(cid);
              }

              if (!(path == null || path === '/')) {
                _context.next = 13;
                break;
              }

              _context.next = 9;
              return ipld.get(cid, options);

            case 9:
              value = _context.sent;
              return _context.abrupt("return", {
                value: value,
                remainderPath: ''
              });

            case 13:
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 15;
              _iterator = _asyncIterator(ipld.resolve(cid, path));

            case 17:
              _context.next = 19;
              return _iterator.next();

            case 19:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 23;
              return _step.value;

            case 23:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 32;
                break;
              }

              entry = _value;

              if (!options.localResolve) {
                _context.next = 28;
                break;
              }

              return _context.abrupt("return", entry);

            case 28:
              result = entry;

            case 29:
              _iteratorNormalCompletion = true;
              _context.next = 17;
              break;

            case 32:
              _context.next = 38;
              break;

            case 34:
              _context.prev = 34;
              _context.t0 = _context["catch"](15);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 38:
              _context.prev = 38;
              _context.prev = 39;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 43;
                break;
              }

              _context.next = 43;
              return _iterator.return();

            case 43:
              _context.prev = 43;

              if (!_didIteratorError) {
                _context.next = 46;
                break;
              }

              throw _iteratorError;

            case 46:
              return _context.finish(43);

            case 47:
              return _context.finish(38);

            case 48:
              return _context.abrupt("return", result);

            case 49:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[15, 34, 38, 48], [39,, 43, 47]]);
    }));

    function get(_x, _x2, _x3) {
      return _get.apply(this, arguments);
    }

    return get;
  }());
};